// extracted by mini-css-extract-plugin
export default {"LikeItemContainer":"LikeItemCollection_LikeItemContainer__6sRTS"};